/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class Navbar extends HTMLElement {
  constructor () {
    super()

    this.handleDropdownsBackdrop()
    this.handleDesktopDropdownOverflow()
    this.enableHoverDropdowns()
    this.handleHeaderReveal()
    this.adjustOffcanvasMenu()
  }

  adjustOffcanvasMenu () {
    const offcanvasMenu = document.querySelector('#offcanvas-menu')
    const navbarMobile = document.querySelector('#navbar-mobile')

    offcanvasMenu?.addEventListener('show.bs.offcanvas', () => {
      const navbarSpacing = document.querySelector('#navbar-mobile').getBoundingClientRect().bottom
      offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`

      navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
    })

    offcanvasMenu?.addEventListener('hide.bs.offcanvas', () => {
      navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
    })
  }

  handleHeaderReveal () {
    let oldScroll = window.scrollY
    const headerGroup = document.querySelector('#header-group')

    window.addEventListener('scroll', () => {
      const newScroll = window.scrollY
      if (newScroll > oldScroll) {
        if (newScroll > headerGroup.clientHeight) {
          headerGroup.classList.add('hide')
        }
      } else if (newScroll < oldScroll) {
        headerGroup.classList.remove('hide')
      }

      oldScroll = Math.max(window.scrollY, 0)
    })
  }

  handleDropdownsBackdrop () {
    this.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
      dropdown.addEventListener('hidden.bs.dropdown', () => {
        if (!document.querySelector('#navbar-desktop .dropdown-toggle.show')) {
          document.body.classList.remove('navbar-dropdown-open')
        }
      })
      dropdown.addEventListener('show.bs.dropdown', () => {
        document.body.classList.add('navbar-dropdown-open')
      })
    })
  }

  handleDesktopDropdownOverflow () {
    const desktopMedia = window.matchMedia('(min-width: 1200px)')
    const viewportPadding = 16

    this.measureDesktopDropdown = (dropdown) => {
      if (!desktopMedia.matches) return

      const menu = dropdown.querySelector('.dropdown-menu')
      if (!menu) return

      menu.classList.remove('dropdown-menu-end')

      const wasShown = menu.classList.contains('show')

      if (!wasShown) {
        menu.style.visibility = 'hidden'
        menu.style.display = 'block'
      }

      const { right } = menu.getBoundingClientRect()
      const shouldAlignEnd = right > window.innerWidth - viewportPadding

      if (!wasShown) {
        menu.style.display = ''
        menu.style.visibility = ''
      }

      menu.classList.toggle('dropdown-menu-end', shouldAlignEnd)
    }

    this.querySelectorAll('#navbar-desktop .dropdown').forEach((dropdown) => {
      const toggle = dropdown.querySelector('.dropdown-toggle')
      if (!toggle) return

      toggle.addEventListener('show.bs.dropdown', () => {
        this.measureDesktopDropdown(dropdown)
      })
    })

    window.addEventListener('resize', () => {
      if (!desktopMedia.matches) return

      this.querySelectorAll('#navbar-desktop .dropdown .dropdown-menu.show').forEach((menu) => {
        this.measureDesktopDropdown(menu.closest('.dropdown'))
      })
    })
  }

  enableHoverDropdowns () {
    if (!window.matchMedia('(hover: hover)').matches) return

    this.querySelectorAll('[data-hover-dropdowns] .dropdown').forEach((dropdown) => {
      const toggle = dropdown.querySelector('.dropdown-toggle')
      if (!toggle) return

      const instance = window.bootstrap.Dropdown.getOrCreateInstance(toggle)

      dropdown.addEventListener('mouseenter', () => {
        this.measureDesktopDropdown?.(dropdown)
        instance.show()
      })

      dropdown.addEventListener('mouseleave', () => {
        instance.hide()
      })
    })
  }
}
customElements.define('navbar-wrapper', Navbar)
